import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatZar } from "@/lib/api";

export default function PackageCard({ pkg, category }) {
  const popular = pkg.most_popular;
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
      className={`relative flex flex-col p-8 md:p-10 h-full border transition-colors duration-500 ${
        popular
          ? "bg-ink text-ivory border-ink"
          : "bg-ivory text-ink border-ink/15"
      }`}
      data-testid={`package-card-${pkg.id || pkg.name}`}
    >
      {popular && (
        <span
          className="absolute -top-3 left-8 label-mono bg-ivory text-ink px-3 py-1"
          data-testid="package-most-popular-badge"
        >
          Most Popular
        </span>
      )}

      <p className="label-mono opacity-60">{category?.name || pkg.category_slug}</p>
      <h3 className="mt-4 font-editorial text-4xl md:text-5xl leading-none">
        {pkg.name}
      </h3>

      <div className="mt-6 flex items-baseline gap-3">
        {pkg.starting_from && (
          <span className="label-mono opacity-60">Starting from</span>
        )}
        <span className="font-editorial text-4xl md:text-5xl">
          {formatZar(pkg.price)}
        </span>
      </div>

      {pkg.description && (
        <p className={`mt-6 leading-relaxed ${popular ? "text-ivory/80" : "text-ink/70"}`}>
          {pkg.description}
        </p>
      )}

      <ul className="mt-8 space-y-3 flex-1">
        {(pkg.features || []).map((f, i) => (
          <li key={i} className="flex items-start gap-3">
            <span
              className={`mt-2 w-3 h-px shrink-0 ${popular ? "bg-ivory/50" : "bg-ink/50"}`}
            />
            <span className={popular ? "text-ivory/90" : "text-ink/85"}>{f}</span>
          </li>
        ))}
      </ul>

      {pkg.turnaround && (
        <p className={`mt-8 label-mono ${popular ? "opacity-70" : "opacity-60"}`}>
          {pkg.turnaround}
        </p>
      )}

      <div className="mt-10">
        <Link
          to={`/booking?category=${encodeURIComponent(pkg.category_slug)}&package=${encodeURIComponent(pkg.name)}`}
          className={popular ? "btn-outline-ivory" : "btn-outline-ink"}
          data-testid={`package-book-btn-${pkg.name.replace(/\s+/g, "-").toLowerCase()}`}
        >
          Book this package
        </Link>
      </div>
    </motion.article>
  );
}
